import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {LoginLockService} from "../../../shared/services/login-lock.service";
import {LoginLock} from "../../../shared/interface/login-lock";
import {LoginLockAddComponent} from "../login-lock-add/login-lock-add.component";
import {
  ConfirmDialogWithReasonComponent
} from "../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {Profile} from "../../../shared/interface/profile";

@Component({
  selector: 'app-all-login-lock-list',
  templateUrl: './all-login-lock-list.component.html',
  styleUrls: ['./all-login-lock-list.component.scss']
})
export class AllLoginLockListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['type', 'startAt', 'user', 'status', 'endAt', 'action'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  dataSource: LoginLock[] = [];
  profile: Profile;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private loginLockService: LoginLockService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.userPermissions = auth.getUserPermissions();
    this.loginLockService.getLoginLockListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<LoginLock>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();
  }

  ngOnInit(): void {
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }
  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  loadListData(): void {
    this.loginLockService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  getStatus(element: any): string {
    const now = new Date();

    if (now < new Date(element.startAt)) {
      return 'Oczekuje';
    }

    if (now <= new Date(element.endAt)) {
      return 'Aktywna';
    }

    return 'Nieaktywna';
  }

  add(): void {
    const dialogRef = this.dialog.open(LoginLockAddComponent, {
      width: '700px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  stop(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz przywrócić możliwość logowania do systemów ASF24 i ASF360?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loginLockService.stop(uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie przywrócono możliwość logowania', '', {duration: 2000});
            this.loadListData();
          });
      }
    });
  }

  // isLockFinished(): boolean {
  //   if (!this.dataSource?.length || !this.dataSource[0]?.endAt) {
  //     return true;
  //   }
  //
  //   return new Date(this.dataSource[0].endAt).getTime() < Date.now();
  // }

  canStop(loginLock: LoginLock): boolean {
    if (loginLock?.endAt) {
      return new Date(loginLock.endAt).getTime() > Date.now() && new Date(loginLock.startAt).getTime() < Date.now();
    }

    return false;
  }
}
